import { useTLang } from 'intl/intl';

import type { UserTagType } from 'shared/domain';

export function useUserTagDescriptionLang({ userTag }: Props) {
  const content = useTLang({
    id: {
      new: 'orderDetailDialogCustomerBox.newUserDescription',
      pro: 'orderDetailDialogCustomerBox.userTypeLabel',
      own: 'orderDetailDialogCustomerBox.propioDescription',
    }[userTag],
  });

  return {
    content,
  };
}

interface Props {
  userTag: UserTagType;
}
